// FBI error 478 - "Victim Connected to an Invalid Combination of Offenses".
//
// Source: 2023.0 NIBRS Technical Specification, Table 5-7 (printed p.181) and
// the numbered prose enumeration (printed pp.177-178). NOT the User Manual.
//
// Chart-reading note: the diagonal is marked with an X in EVERY row. Calibrate
// against row 09A (XX + XXX = diagonal + 09B, then 13A/13B/13C, matching item 1)
// or the chart is misread by one column.
//
// `items` cites the numbered enumeration entries that authorise each pair. A
// pair with no citation must not exist - unwritten pairs are how 11D+13A and
// 36A+36B got in. Pairs are stored canonically with a < b and matched
// order-insensitively.
//
// 09C is NOT here. Its check returns NIBRS-2019.2-27 ("only one Offense entity"),
// which is an incident-level rule and a different error number.
export const OFFENSE_CONFLICTS = [
  // --- Rule 110: homicide (7) - items 1, 5 -------------------------------
  { a: '09A', b: '09B', rule: 'NIBRS-2019.2-110', items: [1, 5] },
  { a: '09A', b: '13A', rule: 'NIBRS-2019.2-110', items: [1] },
  { a: '09A', b: '13B', rule: 'NIBRS-2019.2-110', items: [1] },
  { a: '09A', b: '13C', rule: 'NIBRS-2019.2-110', items: [1] },
  { a: '09B', b: '13A', rule: 'NIBRS-2019.2-110', items: [5] },
  { a: '09B', b: '13B', rule: 'NIBRS-2019.2-110', items: [5] },
  { a: '09B', b: '13C', rule: 'NIBRS-2019.2-110', items: [5] },

  // --- Rule 111: assault (17) - items 2, 3, 4, 6, 7, 8, 9, 12 ------------
  { a: '11A', b: '13A', rule: 'NIBRS-2019.2-111', items: [2, 6] },
  { a: '11A', b: '13B', rule: 'NIBRS-2019.2-111', items: [3, 6] },
  { a: '11A', b: '13C', rule: 'NIBRS-2019.2-111', items: [4, 6] },
  { a: '11B', b: '13A', rule: 'NIBRS-2019.2-111', items: [2, 7] },
  { a: '11B', b: '13B', rule: 'NIBRS-2019.2-111', items: [3, 7] },
  { a: '11B', b: '13C', rule: 'NIBRS-2019.2-111', items: [4, 7] },
  { a: '11C', b: '13A', rule: 'NIBRS-2019.2-111', items: [2, 8] },
  { a: '11C', b: '13B', rule: 'NIBRS-2019.2-111', items: [3, 8] },
  { a: '11C', b: '13C', rule: 'NIBRS-2019.2-111', items: [4, 8] },
  // 11D pairs with 13B and 13C ONLY. Item 9 names Simple Assault and
  // Intimidation as lesser-included of Fondling; Aggravated Assault is absent,
  // and item 2 omits Fondling from Agg Assault's list. Chart row 13A marks
  // 11A/11B/11C and stops before 11D.
  { a: '11D', b: '13B', rule: 'NIBRS-2019.2-111', items: [3, 9] },
  { a: '11D', b: '13C', rule: 'NIBRS-2019.2-111', items: [4, 9] },
  { a: '120', b: '13A', rule: 'NIBRS-2019.2-111', items: [2, 12] },
  { a: '120', b: '13B', rule: 'NIBRS-2019.2-111', items: [3, 12] },
  { a: '120', b: '13C', rule: 'NIBRS-2019.2-111', items: [4, 12] },
  { a: '13A', b: '13B', rule: 'NIBRS-2019.2-111', items: [2] },
  { a: '13A', b: '13C', rule: 'NIBRS-2019.2-111', items: [2] },
  { a: '13B', b: '13C', rule: 'NIBRS-2019.2-111', items: [3] },

  // --- Rule 112: fondling vs forcible sex offenses (3) - items 6, 7, 8, 9 -
  { a: '11A', b: '11D', rule: 'NIBRS-2019.2-112', items: [6, 9] },
  { a: '11B', b: '11D', rule: 'NIBRS-2019.2-112', items: [7, 9] },
  { a: '11C', b: '11D', rule: 'NIBRS-2019.2-112', items: [8, 9] },

  // --- Rule 113: incest / statutory rape (8) - items 6-11 ----------------
  { a: '11A', b: '36A', rule: 'NIBRS-2019.2-113', items: [6, 10] },
  { a: '11A', b: '36B', rule: 'NIBRS-2019.2-113', items: [6, 11] },
  { a: '11B', b: '36A', rule: 'NIBRS-2019.2-113', items: [7, 10] },
  { a: '11B', b: '36B', rule: 'NIBRS-2019.2-113', items: [7, 11] },
  { a: '11C', b: '36A', rule: 'NIBRS-2019.2-113', items: [8, 10] },
  { a: '11C', b: '36B', rule: 'NIBRS-2019.2-113', items: [8, 11] },
  { a: '11D', b: '36A', rule: 'NIBRS-2019.2-113', items: [9, 10] },
  { a: '11D', b: '36B', rule: 'NIBRS-2019.2-113', items: [9, 11] },
  // 36A + 36B is NOT a conflict: items 10 and 11 each list only 11A-11D.

  // --- Rule 114: robbery vs theft (9) - item 12 -------------------------
  { a: '120', b: '23A', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '23B', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '23C', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '23D', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '23E', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '23F', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '23G', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '23H', rule: 'NIBRS-2019.2-114', items: [12] },
  { a: '120', b: '240', rule: 'NIBRS-2019.2-114', items: [12] },
  // 23I is absent: it is not a NIBRS offense code (23A-23H only).
];

/**
 * First conflicting pair present in `codes`, or null.
 * Order-insensitive; tolerant of nullish/non-array input (returns null).
 */
export const findOffenseConflict = (codes) => {
  if (!Array.isArray(codes) || codes.length < 2) return null;
  const present = new Set(codes);
  for (const c of OFFENSE_CONFLICTS) {
    if (present.has(c.a) && present.has(c.b)) return c;
  }
  return null;
};
